import { gql } from 'glimmer-apollo';

// Feeds the persistent live score strip (ESPN "BottomLine").
// Every field here is confirmed present on the backend schema. Notes on the
// backend's real behaviour (verified via introspection + probing):
//   - `matches` has no `orderBy` arg, and the `isLive` filter is a no-op, so we
//     fetch a single batch and split live / final CLIENT-SIDE.
//   - there is no stored score field, so scores are derived by counting the
//     round victors.
export const ESPORTS_SCORE_STRIP_QUERY = gql`
  query EsportsScoreStrip {
    matches(limit: 100) {
      slug
      title
      name
      isLive
      isFinal
      bestOf
      scheduledDate
      teams {
        name
        slug
        logo {
          url(width: 40, height: 40, fit: cover, format: webp)
        }
      }
      rounds {
        victor {
          slug
        }
      }
      tournament {
        name
        slug
      }
    }
  }
`;
